<template>
  <div class="main-certificate">
    <div class="main-certificate__top">
      <div class="main-title main-certificate__title">
        <h2>
          прикрепляем к нам
          <br>
          без партнеров
        </h2>
      </div>

      <p class="main-certificate__description">
        учитесь на заочной и семейной форме обучения
        <br>
        в контингенте <span>московской школы</span>
      </p>
    </div>

    <div class="main-certificate__tabs">
      <button
        v-for="item of tabs"
        :key="item.id"
        :ref="'tab-' + item.id"
        :class="[
          'main-certificate__tabs--item',
          {'main-certificate__tabs--item-active': item.isActive},
        ]"
        @click="setActiveTab(item.id)"
      >
        {{ item.label }}
      </button>
    </div>

    <transition
      :name="transitionName"
      mode="out-in"
    >
      <div
        v-if="activeSlide"
        :key="activeSlide.id"
        :class="[
          'main-certificate__slide',
          activeSlide.className,
        ]"
      >
        <h5 v-html="activeSlide.title" />

        <p
          v-if="activeSlide.description"
          v-html="activeSlide.description"
        />

        <img
          v-if="activeSlide.sticker"
          :src="activeSlide.sticker"
          alt="sticker"
        >

        <button @click="openModal">
          {{ activeSlide.btnText }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { MODAL_TYPES } from '@/components/v2/common/AppHeader/data';

export default {
  name: 'MainCertificate',
  data: () => ({
    activeTab: 1,
    previousTab: 1,
  }),
  computed: {
    ...mapGetters({
      isResponsiveTablet: 'isResponsiveTablet',
    }),
    transitionName() {
      return this.activeTab > this.previousTab
        ? 'slide-right'
        : 'slide-left';
    },
    tabs() {
      return [
        {
          id: 1,
          label: 'аттестат гос. образца',
          isActive: this.activeTab === 1,
        },
        {
          id: 2,
          label: 'московская медаль',
          isActive: this.activeTab === 2,
        },
        {
          id: 3,
          label: 'аттестация',
          isActive: this.activeTab === 3,
        },
        {
          id: 4,
          label: 'поступление в вузы мира',
          isActive: this.activeTab === 4,
        },
      ];
    },
    slides() {
      return [
        {
          id: 1,
          // eslint-disable-next-line max-len,vue/max-len
          title: 'мы выдаем аттестаты <span>самостоятельно</span>, <br>а не через партнеров, как это делают <br>другие онлайн-школы',
          // eslint-disable-next-line max-len,vue/max-len
          description: 'получите <span>московский аттестат гос. образца</span> <br>от московского школьного университета, обучаясь <br>по современным стандартам <br class="mobile-br">ФГОС и ФООП',
          sticker: null,
          btnText: 'начать учиться',
          className: 'main-certificate__slide--1',
        },
        {
          id: 2,
          // eslint-disable-next-line max-len,vue/max-len
          title: 'учитесь онлайн из других регионов, <br>с возможностью получить <span>московскую</span> <br>медаль отличия',
          // eslint-disable-next-line max-len,vue/max-len
          description: 'вузы России начисляют <span>дополнительные баллы</span> <br>за московскую медаль, повышая <br>конкурентоспособность абитуриентов',
          sticker: null,
          btnText: 'начать учиться',
          className: 'main-certificate__slide--2',
        },
        {
          id: 3,
          // eslint-disable-next-line max-len,vue/max-len
          title: 'не нужно искать школу <br class="mobile-br">для аттестации — <br>сдавайте <br class="tablet-br">ее <span>онлайн</span> с нашими <br>преподавателями и кураторами <br><br class="tablet-br">в привычной обстановке',
          // eslint-disable-next-line max-len,vue/max-len
          description: null,
          sticker: null,
          btnText: 'начать учиться',
          className: 'main-certificate__slide--3',
        },
        {
          id: 4,
          // eslint-disable-next-line max-len,vue/max-len
          title: 'с нашими аттестатом вы сможете <br>поступить в любой вуз мира <br class="mobile-br">или мы <br>поможем получить <span>двойной диплом:</span> <br>российский и международный',
          // eslint-disable-next-line max-len,vue/max-len
          description: null,
          sticker: `/v2/main/certificate/sticker${this.isResponsiveTablet ? '-tablet' : ''}.webp`,
          btnText: 'узнать подробнее',
          className: 'main-certificate__slide--4',
        },
      ];
    },
    activeSlide() {
      return this.slides.find(({ id }) => id === this.activeTab) || null;
    },
  },
  methods: {
    ...mapActions('appHeaderModals', {
      storyOpenModal: 'openModal',
      setModalComment: 'setModalComment',
    }),
    openModal() {
      this.storyOpenModal(MODAL_TYPES.skills);
      this.setModalComment('прикрепляем к нам без партнеров');
    },
    setActiveTab(value) {
      this.previousTab = this.activeTab;
      this.activeTab = value;

      this.$nextTick(() => {
        const tabElement = this.$refs[`tab-${value}`];
        if (tabElement && tabElement[0]) {
          tabElement[0].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-certificate {
  &__top {
    display: flex;
    gap: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      flex-direction: column;
      gap: calc(var(--scale) * 8);
    }
  }

  &__title {
    width: calc(50% - (var(--scale) * 10));

    font-size: calc(var(--scale) * 86);
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.04em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #02120F;

    @include media-down($size-tablet) {
      width: calc(50% - (var(--scale) * 4));

      font-size: calc(var(--scale) * 40);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }
  }

  &__description {
    width: calc(50% - (var(--scale) * 10));
    padding-top: calc(var(--scale) * 32);

    font-size: calc(var(--scale) * 32);
    font-weight: 500;
    line-height: 110%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #A7ABAC;

    span {
      color: #5237E6;
    }

    @include media-down($size-tablet) {
      width: calc(50% - (var(--scale) * 4));
      padding-top: 0;

      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      letter-spacing: -0.03em;
    }

    @include media-down($size-mobile) {
      width: 100%;
    }
  }

  &__tabs {
    width: calc(100% + var(--scale) * 80);
    margin-top: calc(var(--scale) * 18);
    margin-inline: calc(var(--scale) * -40);
    padding-inline: calc(var(--scale) * 40);
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    display: flex;
    gap: calc(var(--scale) * 8);

    @include media-down($size-tablet) {
      width: calc(100% + var(--scale) * 32);
      margin-top: calc(var(--scale) * 24);
      margin-inline: calc(var(--scale) * -16);
      padding-inline: calc(var(--scale) * 16);

      gap: calc(var(--scale) * 4);
    }

    @include media-down($size-tablet) {
      width: calc(100% + var(--scale) * 24);
      margin-inline: calc(var(--scale) * -12);
      padding-inline: calc(var(--scale) * 12);
    }

    &--item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(var(--scale) * 99);
      padding: 0 calc(var(--scale) * 54);

      border: none;
      border-radius: calc(var(--scale) * 200);
      background-color: $white-color;

      font-size: calc(var(--scale) * 32);
      font-weight: 500;
      line-height: 110%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      white-space: nowrap;
      color: #A7ABAC;

      cursor: pointer;
      transition: background-color .2s ease-out, color .2s ease-out;

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 52);
        padding: 0 calc(var(--scale) * 22);

        font-size: calc(var(--scale) * 18);
      }

      &:hover, &-active {
        background-color: #5237E6;
        color: $white-color;
      }
    }
  }

  &__slide {
    margin-top: calc(var(--scale) * 23);
    padding: calc(var(--scale) * 32)
    calc(var(--scale) * 40)
    calc(var(--scale) * 40)
    calc(var(--scale) * 40);
    box-sizing: border-box;
    height: calc(var(--scale) * 505);

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    border-radius: calc(var(--scale) * 60);
    background-color: $white-color;

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 16);
      padding: calc(var(--scale) * 16)
      calc(var(--scale) * 8)
      calc(var(--scale) * 8)
      calc(var(--scale) * 8);
      height: calc(var(--scale) * 270);

      border-radius: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      padding: calc(var(--scale) * 20)
      calc(var(--scale) * 8)
      calc(var(--scale) * 8)
      calc(var(--scale) * 8);
      height: calc(var(--scale) * 512);
    }

    h5 {
      font-size: calc(var(--scale) * 48);
      font-weight: 500;
      line-height: 110%;
      letter-spacing: -0.02em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #02120F;

      ::v-deep span {
        color: #5237E6;
      }

      ::v-deep .tablet-br {
        display: none;
      }

      ::v-deep .mobile-br {
        display: none;
      }

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 334);
        padding-left: calc(var(--scale) * 8);

        font-size: calc(var(--scale) * 20);

        ::v-deep br {
          display: none;
        }

        ::v-deep .tablet-br {
          display: block;
        }
      }

      @include media-down($size-mobile) {
        ::v-deep .mobile-br {
          display: block;
        }
      }
    }

    p {
      margin-top: calc(var(--scale) * 12);

      font-size: calc(var(--scale) * 26);
      font-weight: 500;
      line-height: 120%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #A7ABAC;

      ::v-deep span {
        color: #5237E6;
      }

      ::v-deep .mobile-br {
        display: none;
      }

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 348);
        padding-left: calc(var(--scale) * 8);
        margin-top: calc(var(--scale) * 8);

        font-size: calc(var(--scale) * 16);
        line-height: 130%;
        font-weight: 400;
        letter-spacing: -0.06em;

        ::v-deep br {
          display: none;
        }
      }

      @include media-down($size-mobile) {
        letter-spacing: -0.02em;

        ::v-deep .mobile-br {
          display: block;
        }
      }
    }

    img {
      margin-top: calc(var(--scale) * 16);
      width: calc(var(--scale) * 539);

      @include media-down($size-tablet) {
        margin-top: calc(var(--scale) * 8);
        margin-left: calc(var(--scale) * 8);
        width: calc(var(--scale) * 268);
      }
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      height: calc(var(--scale) * 122);
      margin-top: auto;
      padding: 0 calc(var(--scale) * 56);

      border: none;
      border-radius: calc(var(--scale) * 40);
      background-color: #FF5319;

      font-size: calc(var(--scale) * 32);
      font-weight: 500;
      line-height: 110%;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: $white-color;

      cursor: pointer;
      transition: background-color .2s ease-out;

      &:hover {
        background-color: #ff9c12;
      }

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 80);

        border-radius: calc(var(--scale) * 24);

        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        width: 100%;
      }
    }

    &--1 {
      background-image: url("/v2/main/certificate/slide-1-bg.webp");
      background-size: cover;
      background-position: center center;

      @include media-down($size-tablet) {
        background-image: url("/v2/main/certificate/slide-1-bg-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/main/certificate/slide-1-bg-mobile.webp");
      }
    }

    &--2 {
      background-image: url("/v2/main/certificate/slide-2-bg.webp");
      background-size: cover;
      background-position: center center;

      @include media-down($size-tablet) {
        background-image: url("/v2/main/certificate/slide-2-bg-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/main/certificate/slide-2-bg-mobile.webp");
      }
    }

    &--3 {
      background-image: url("/v2/main/certificate/slide-3-bg.webp");
      background-size: cover;
      background-position: center center;

      @include media-down($size-tablet) {
        background-image: url("/v2/main/certificate/slide-3-bg-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/main/certificate/slide-3-bg-mobile.webp");
      }
    }

    &--4 {
      background-image: url("/v2/main/certificate/slide-4-bg.webp");
      background-size: cover;
      background-position: center center;

      @include media-down($size-tablet) {
        background-image: url("/v2/main/certificate/slide-4-bg-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/main/certificate/slide-4-bg-mobile.webp");
      }
    }
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform .3s ease, opacity .3s ease;
}

.slide-right-enter-from,
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(25%);
}

.slide-right-leave-to,
.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-25%);
}

.slide-right-enter-to,
.slide-right-leave-from,
.slide-left-enter-to,
.slide-left-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>
